export default `<p>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">在此特别提醒您</span>(<span style="font-family:宋体">用户
</span>
    <span style="font-family:Calibri">)
</span>
    <span style="font-family:宋体">在成为用户之前，请认真阅读本《</span>
</span>
    <span style=";font-family:宋体;font-size:14px">服务
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">协议》</span>(<span style="font-family:宋体">以下简称”协议
</span>
    <span style="font-family:Calibri">&quot;)
</span>
    <span style="font-family:宋体">，确保你充分理解本协议中各条款。请你审慎阅读并选择接受或不接受本协议。除非你接受本协议所有条款否则你无权使用本协议所涉服务。你的购买、使用等行为将视为对本协议的接受，并同意接受本协议各项条款的约。本协议可由</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">随时更新，更新后的协议条款一旦公布即代
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">提供的服务，用户继续使用
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">提供的服务将被视为接受修改后的协议</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">一、服务内容</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">1<span style="font-family:宋体">、本服务的具体内容由</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">根据实际情况提供，包括但不限于授权用户通过使用</span>“
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">”实现群和好友的数据管理和消息处理等功能。
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">可以对其提供的服务予以变更，且
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">提的服务内容可能随时变更
</span>
    <span style=";font-family:宋体;font-size:14px">，
</span>
    <span style=";font-family:宋体;font-size:14px">支付一定数额的人民币购买用户欲使用的收费服务，从而获得收费服务使用权限。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2<span style="font-family:宋体">、“</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">”中的服务为收费服务。用户可以通过付费方式购买服务，具体方式为<span style="font-family:Calibri">: 
</span>
    <span style="font-family:宋体">用户通过</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">会在用户使用之前给予用户明确的提示，只有用户根据提示确认其同意按照前述支付方式支付费用并完成了支付行为，用户才能使用该收费服务。支付行为的完成以支付宝平台生成</span>&quot;<span style="font-family:宋体">支付成功”的确认通知</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">二、用户个人隐私信息保护</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">1<span style="font-family:宋体">、个人隐私信息是指涉及用户个人身份或个人隐私的信息，比如，用户真实姓名、身份证号、手</span>
</span>
    <span style=";font-family:宋体;font-size:14px">机
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">号码、手机设备识别码、</span>IP<span style="font-family:宋体">地址、用户聊天记录。非个人隐私信息是指用户对本服务的操作状态以及使用等明确且客观反映在</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">服务器端的基本记录信息、个人隐私信息范围外的其它普通信息，以及用户同意公开的上述隐私信息。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2<span style="font-family:宋体">、尊重用户个人隐私信息的私有性是</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">的一贯制度，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">将采取技术措施和其他要措施，确保用户个人隐私信息安全，防止在本服务中收集的用户个人隐私信息泄露、毁损或丢失。在发生述情形或者
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">发现存在发生前述情形的可能时，将及时采取补救措施。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3<span style="font-family:宋体">、</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">未经用户同意不向任何第三方公开、透露用户个人隐私信息。但以下特定情形除外</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3.1 
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">根据法律法规规定或有权机关的指示提供用户的个人隐私信息</span>;</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3.2 <span style="font-family:宋体">由于用户将其用户密码告知他人或与他人共享注册账户与密码，由此导致的任何个人信息的泄漏，或其他非因</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">原因导致的个人隐私信息的泄露</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3.3 <span style="font-family:宋体">用户自行向第三方公开其个人隐私信息
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3.4 <span style="font-family:宋体">用户与</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">及合作单位之间就用户个人隐私信息的使用公开达成约定，由
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">因此向合作单位公开用户个人隐私信息</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3.5 <span style="font-family:宋体">任何由于黑客攻击、电脑病毒侵入及其他不可抗力事件导致用户个人隐私信息的泄露</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">4<span style="font-family:宋体">、用户同意</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">可在以下事项中使用用户的个人隐私信息</span>:</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">4.1 
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">向用户及时发送重要通知，如软件更新、本协议条款的变更</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">4.2 
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">内部进行审计、数据分析和研究等，以改进
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">的产品、服务和与用户间的沟通</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">4.3 <span style="font-family:宋体">依本协议约定，</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">管理、审查用户信息及进行处理措施</span>:</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">4.4 <span style="font-family:宋体">适用法律法规规定的其他事项。 除上述事项外，如未取得用户事先同意，</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">不乡将用户个人隐私信息使用于任何其他用途</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">5<span style="font-family:宋体">、为了改善</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">的技术和服务，向用户提供更好的服务体验，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">或可会自行收集用或向第三方提供用户的非个人隐私信息。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">三、内容规范</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">1<span style="font-family:宋体">本条所达内容是指用产使用本服务过程中所制作、上载、</span>
</span>
    <span style=";font-family:宋体;font-size:14px">复制
</span>
    <span style=";font-family:宋体;font-size:14px">、发布、传播的任内客，包括但不限于头、名称、文字、语音、图片、视频、图文等发送、回复或自动回复消息和相关进接页面，以及其他使用所产生的内容</span>
</p>
<p>
    <span style="font-family:宋体;font-size:14px">2、
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">用户不得利用</span>“
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">&quot;<span style="font-family:宋体">制作、上载、复制、发布、传播如下法律、法规和政策禁止的内容，一经发现，</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">有权立刻停止服务且不会退还任何费用</span>:</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.1<span style="font-family:宋体">反对宪法所确定的基本原则的
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.2 <span style="font-family:宋体">危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.3 <span style="font-family:宋体">损害国家荣誉和利益的
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.4 <span style="font-family:宋体">煽动民族仇恨、民族歧视，破坏民族团结的</span>
</span>
    <span style=";font-family:宋体;font-size:14px">；</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.5 <span style="font-family:宋体">破坏国家宗教政策，宣扬邪教和封建迷信的</span>
</span>
    <span style=";font-family:宋体;font-size:14px">；</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.6 <span style="font-family:宋体">散布谣言，扰乱社会秩序，破坏社会稳定的</span>
</span>
    <span style=";font-family:宋体;font-size:14px">；</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.7 <span style="font-family:宋体">散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.8 <span style="font-family:宋体">侮辱或者诽谤他人，侵害他人合法权益的
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.9 <span style="font-family:宋体">不遵守法律法规底线、社会主义制度底线、国家利益底线、公民合法权益底线、社会公共秩序底线、道德风尚底线和信息真实性底线的
</span>
    <span style="font-family:Calibri">&quot;
</span>
    <span style="font-family:宋体">七条底线
</span>
    <span style="font-family:Calibri">&quot;
</span>
    <span style="font-family:宋体">要求的</span>
</span>
    <span style=";font-family:宋体;font-size:14px">；</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.10 <span style="font-family:宋体">含有法律、行政法规禁止的其他内容的信息。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3<span style="font-family:宋体">、用户不得利用</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">&quot;<span style="font-family:宋体">制作、上载、复制、发布、传播如下干扰</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">常运营，以及侵犯其他用户或第三方合法权益的内容，一经发现，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">有权立刻止服务目不会退还任何费用</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3.1 <span style="font-family:宋体">含有任何性或性暗示的
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3.2 <span style="font-family:宋体">含有辱骂、恐吓、威胁内容的
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3.3 <span style="font-family:宋体">含有骚扰、垃圾广告、恶意信息、诱骗信息的</span>
</span>
    <span style=";font-family:宋体;font-size:14px">；</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3.4 <span style="font-family:宋体">涉及他人隐私、个人信息或资料的
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3.5 <span style="font-family:宋体">侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3.6 <span style="font-family:宋体">含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">四、使用规则</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">1<span style="font-family:宋体">、用户在本服务中或通过本服务所传送、发布的任何内容并不反映或代表，也不得被视为反映或代表</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">的观点、立场或政策，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">对此不承担任何责任</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2<span style="font-family:宋体">、用户不得利用”</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">”进行如下行为，一经发现，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">有权立刻停止服务且不会退还任何费用</span>:</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.1 <span style="font-family:宋体">提交、发布虚假信息，或盗用他人头像或资料，冒充、利用他人名义的
</span>
    <span style="font-family:Calibri">:</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.2 <span style="font-family:宋体">强制其他用户关注、点击链接页面或分享信息的
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2 3 <span style="font-family:宋体">虑构事实，隐瞒直相以误导、欺骗他人的
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.4 <span style="font-family:宋体">利用技术手段批量建立虚假的
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.5 <span style="font-family:宋体">利用”</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">”从事任何违法犯罪活动的<span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2
</span>
    <span style=";font-family:宋体;font-size:14px">.
</span>
    <span style=";font-family:宋体;font-size:14px">6
</span>
    <span style=";font-family:宋体;font-size:14px">&nbsp;
</span>
    <span style=";font-family:宋体;font-size:14px">制作，发布与以上行为相关的方法，工具，或对此类方法，工具进行运营或传播，无论这些行为是否为商业目的</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2
</span>
    <span style=";font-family:宋体;font-size:14px">.
</span>
    <span style=";font-family:宋体;font-size:14px">7<span style="font-family:宋体">其他违反法律法规规定，侵犯其他用户合法权益、干扰”</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">”正常运营或
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">未明示授权的行为。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">五、账户管理</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">1
</span>
    <span style=";font-family:宋体;font-size:14px">，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体所有权归
</span>
    <span style="font-family:Calibri">Ai
</span>
    <span style="font-family:宋体">智能体所</span>
</span>
    <span style=";font-family:宋体;font-size:14px">有、
</span>
    <span style=";font-family:宋体;font-size:14px">用户完
</span>
    <span style=";font-family:宋体;font-size:14px">成
</span>
    <span style=";font-family:宋体;font-size:14px">购买
</span>
    <span style=";font-family:宋体;font-size:14px">开通后获得
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">的使使用
</span>
    <span style=";font-family:宋体;font-size:14px">权
</span>
    <span style=";font-family:宋体;font-size:14px">，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体因经营需要，</span>
</span>
    <span style=";font-family:宋体;font-size:14px">有权回收用
</span>
    <span style=";font-family:宋体;font-size:14px">户
</span>
    <span style=";font-family:宋体;font-size:14px">的所有使用权
</span>
    <span style=";font-family:宋体;font-size:14px">。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2<span style="font-family:宋体">、用户可以更改、删除</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">账户上的个人资料、注册信息及传送内容等，但需注意，删除有关信息的同时也会删除用户情存在系统中的文字和图片。用户需承担该风险。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3<span style="font-family:宋体">、用户应遵守本协议的各项条款、正确、适当地使用本服务，如因用户违反本协议中的任何条款、</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">有权依据协议中断或终上对违约用户提供服务。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">六、数据储存</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">1<span style="font-family:宋体">、</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">不对用户在本服务中相关数据的删除或储存失败负责</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2<span style="font-family:宋体">、</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">可以根据实际情况自行决定用户在本服务中数据的最长储存期限，并在服务器上为其分配数据最大存储空间等，用户可根据自己的需要自行备份本服务中的相关数据</span>.</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3<span style="font-family:宋体">、如用户停止使用本服务终止，</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">可以从服务器上永久地删除用户的数据。本服务停止、终止后，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">没有义务向用户返还任何数据。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">七、风险承担</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">用户必须为自己使用下的一切行为负责，包括用户所传送的任内客以及由此产生的任后果。用户对</span>&quot;GeMe<span style="font-family:宋体">架
</span>
    <span style="font-family:Calibri">&quot;
</span>
    <span style="font-family:宋体">及本服务中的内容自行加以判，并承担因使用内容而起的所有风，包因对内容的正确性、完整性或实用性的依</span></span>
</p>
<p>
    <span style="font-family:宋体;font-size:14px">1、
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">用户理解并同意，</span>&quot;
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">”仅为用户提供好友管理、社群维护、内容发布的平台，赖而产生的风险。
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">无法且不会对因用户行为而导致的任何损失或损害承招责任如果用户发现任何人违反本协议约定或以其他不当的方式使用本服务，请立即向
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">举报或投诉，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">将依本协议约定进行处理。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2<span style="font-family:宋体">、用户理解</span>
</span>
    <span style=";font-family:宋体;font-size:14px">并
</span>
    <span style=";font-family:宋体;font-size:14px">同意，因业务发展需要，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">保留单方面对本服务的全部或部分服务内容变更、暂停、终止或撤销的权利，用户需承担此风险。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3<span style="font-family:宋体">、你对本服务条款及修改有任何异议，可自动放弃其资格，</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">不支持因本协议中第十条款</span>:<span style="font-family:宋体">不可抗力及其他免责事由发起的任何浪费电请。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">4<span style="font-family:宋体">、</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">仅支持在注册之日起</span>24<span style="font-family:宋体">小时内，且本协议中第十条款
</span>
    <span style="font-family:Calibri">:
</span>
    <span style="font-family:宋体">不可抗力及其他免责事由表述之外的事由发起的退费申请，逾期将不支持任何退费申请。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">八、知识产权声明</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">1
</span>
    <span style=";font-family:宋体;font-size:14px">、
</span>
    <span style=";font-family:宋体;font-size:14px">除本服务中涉及广告的知识产权由相应广告商享有外
</span>
    <span style=";font-family:宋体;font-size:14px">，
</span>
    <span style=";font-family:宋体;font-size:14px">有特别声明外，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">提供本服务时所依托软件的著作权、专利权及其他知识产权均归
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2
</span>
    <span style=";font-family:宋体;font-size:14px">、
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">在本服务中所涉及的图形、文字或其组成，以及其他
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">标志及
</span>
    <span style=";font-family:宋体;font-size:14px">产
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">标识</span>”，其著作权或商标权
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">归</span>AI<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">所有。未
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">经</span>Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">事先面同意，用产不得将
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">以任方式展示使用作其地处理，也不得自人表明用产有权展示、使用、或其他有权处
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">标识的行为</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3
</span>
    <span style=";font-family:宋体;font-size:14px">、上述及其他任何
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">或相关广告商依法拥有的知识产权均受到法律保护，未经
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">或相关广告商书面许可，用户不得以任何形式进行使用或创造相关衍生作品九、法律责任</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">十、不可抗力及其他免责事由</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">1<span style="font-family:宋体">、用户理解并确认，在使用本服务的过程中，可能会遇到不可抗力等风险因素，使本服务发生中断。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、瘟疫流行和风暴等以及社会事件如战争动乱、政府行为等。出现上述情况时，</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">将努力在第一时间与相关单位配合，及时进行修复，但是由此给用户或第三方造成的损失，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">及合作单位在法律允许的范围内免责。</span>2<span style="font-family:宋体">、本服务同大多数互联网服务一样，受包括但不限于用户原因、网络服务质量、社会环境等因素的差异影响，可能受到各种安全问题的侵扰，如他人利用用户的资料，造成现实生活中的骚扰，用户下载安装的其它软件或访问的其他网站中含有“特洛伊木马”等病毒，威胁到用户的计算机信息和数据的安全，继而影响本服务的正常使用等等。用户应加强信息安全及使用者资料的保护意识，要注意加强密码保护，免遭致损失和骚扰。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3<span style="font-family:宋体">、用户理解并确认，本服务存在因不可抗力、计算机病毒或黑客攻击、系统不稳定、用户所在位置、用户关机以及其他任何技术、互联网络、通信线路原因等造成的服务中断或不能满足用户要求的风险，因此导致的用户或第三方任何损失，</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">不承担任何责任责任。的、威胁性的、诽谤性的、令人反感的或非法的信息，或侵犯他人权利的匿名或冒名的信息以及伴随该等信息的行为，因此导致的用户或第三方的任何损失，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">不承担任何
</span>
    <span style=";font-family:宋体;font-size:14px">损失</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">4<span style="font-family:宋体">、用户理解并确认，在使用本服务过程中存在来自任何他人的包括误导性的、欺骗性</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">5<span style="font-family:宋体">、用户理解并确认，</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">需要定期或不定期地对</span>”
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">”平台或相关的设备进行检修或者维护，如因此类情况而造成服务在合理时间内的中断，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">无需为此担任何责任。利不构成
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">的义务或承诺，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">不能保证及时发现违法违规或违约行为或进相应处理</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">6<span style="font-family:宋体">、</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">依据法律法规、本协议约定获得处理违法违规或违约内容的权利</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">7<span style="font-family:宋体">、用户理解并确认，对于</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">向用户提供的下列产品或者服务的质量缺陷及其引发的任何损失，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">无需承担任何责任</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">8<span style="font-family:宋体">、在任何情况下，</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">均不对任何间接性、后果性、惩罚性、偶然性、特殊性或刑罚性的损害，包括因用户使用</span>”
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">”而遭受的利润损失，承担责任 。尽管本协议中可能含有相悖的规定，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">对用承担的全部责任，无论因何原因或何种行为方式，始终不超过用户因使用
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">提供的服务而支付给
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">的费用</span>(<span style="font-family:宋体">如有
</span>
    <span style="font-family:Calibri">)
</span>
    <span style="font-family:宋体">。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">9<span style="font-family:宋体">、用户理解并确认，由于用户账号被封禁、封号、限制登录、服务中断等情况导致的无法使用服务，不予以退款，</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">不承担任何责任。责任。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">10<span style="font-family:宋体">、用户理解并确认，由用户个人使用行为未遵守微信平台规范导致的账号被封禁寸号、限制登录、服务中断等情况导致的无法使用服务，不予以退款，</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">不承担任</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">&nbsp;</span>
</p>
<p>
    <span style="font-family:宋体;font-size:14px">十一、
</span>
    <span style=";font-family:宋体;font-size:14px">服务的变更、中断、终止</span>
</p>
<p>
    <span style="font-family:宋体;font-size:14px">1、
</span>
    <span style=";font-family:宋体;font-size:14px">鉴于网络服务的特殊性，用户同意
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px"><span style="font-family:宋体">有权随时变更、中断或终止部变更、中断或终止之前通知用户，并应向受影响的用户提供等值的替代性的服务</span>;<span style="font-family:宋体">如用户不愿意接受替代性的服务，则双方根据实际情况本着友好协商的原分或全部的服务 
</span>
    <span style="font-family:Calibri">(
</span>
    <span style="font-family:宋体">包括收费服务
</span>
    <span style="font-family:Calibri">)
</span>
    <span style="font-family:宋体">。</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">变更、中断或终止的服务，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">应当在则，具体商议合理的解决方案。</span>
</p>
<p style="margin-left:0;text-indent:0">
    <span style="font-family:宋体;font-size:14px">2、
</span>
    <span style=";font-family:宋体;font-size:14px">如发生下列任何一种情形，
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">有权变更、中断或终止向用户提供的收费服务，而无需对用户或任何第三方承担任何责任</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.1 <span style="font-family:宋体">根据法律规定用户应提交真实信息，而用户提供的个人资料不真实又能提供合理证明
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.2 <span style="font-family:宋体">用户违反相关法律法规或本协议的约定
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.3 <span style="font-family:宋体">按照法律规定或有权机关的要求
</span>
    <span style="font-family:Calibri">;</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.4 <span style="font-family:宋体">出于安全的原因或其他必要的情形</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2.5 <span style="font-family:宋体">由于微信平台的原因导致的情况。</span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">十二、其他</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">1<span style="font-family:宋体">、</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">郑重提醒用户注意本协议中免除
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">责任和限制用户权利内条款，请用户仔细阅读，自主考虑风险。未成年人应在法定监护人的陪同下阅读本协议。</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">2<span style="font-family:宋体">、本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。若用户利</span>
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，用户同意将纠纷或争议提交
</span>
    <span style=";font-family:宋体;font-size:14px">Ai<span style="font-family:宋体">智能体</span>
</span>
    <span style=";font-family:宋体;font-size:14px">住所地有管辖权的人民法院管辖</span>
</p>
<p>
    <span style=";font-family:宋体;font-size:14px">3<span style="font-family:宋体">、本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效对双方具有约束力。</span></span>
</p>
<p>
    <span style=";font-family:Calibri;font-size:14px">&nbsp;</span>
</p>
<p>
    <br/>
</p>`